import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { style } from "./config";
import { FaArrowLeft } from "react-icons/fa";
import { CiSettings } from "react-icons/ci";
import { FiSend } from "react-icons/fi";

const ClosePositionModal = ({ modal }) => {
  return (
    <Modal
      open={modal.isOpen}
      onClose={modal.close}
      aria-labelledby="chat-modal-title"
      aria-describedby="chat-modal-description"
      className="backdrop-blur-[1px] bg-transparent"
    >
      <Box
        sx={style}
        className="bg-white  md:max-w-[722px] max-w-[370px]  h-screen w-full md:w-[680px] "
      >
        <div className="py-[38px] h-full max-h-[15vh] px-[25px] flex items-center justify-between bg-[#F4F2F9] ">
          <button onClick={modal.close}>
            <span>
              <FaArrowLeft size={25} />
            </span>
          </button>
          <div className="flex gap-5 items-center">
            <span>
              <img src="/blackman.png" />
            </span>
            <p className="text-center justify-center text-[#3c3c3c] text-base font-medium font-['Inter']">
              Feyikemi Toluwani
            </p>
          </div>
          <span>
            <CiSettings size={25} />
          </span>
        </div>

        <div className="flex items-end  h-[85vh] p-10">
          <div className="w-full flex gap-5 items-center">
            <div className="w-full h-16 px-[30px]  bg-[#eae9e9] rounded-[100px] inline-flex flex-col justify-center items-start gap-2.5">
              <input
                type="text"
                placeholder="Type a message"
                className="text-black text-base w-full focus:outline-none font-normal font-['Lato'] leading-normal bg-transparent"
              />
            </div>
            <button className="min-w-[60px] h-[60px] p-[7px] bg-[#8147E7] rounded-[100px] inline-flex justify-center items-center overflow-hidden">
              <span className="text-white text-2xl">
                <FiSend />
              </span>
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ClosePositionModal;
